<!--
 * @Author: 仙道
 * @Date: 2022-10-18 00:03:10
 * @LastEditTime: 2022-10-27 16:02:28
 * @email: hao.li08@weimob.com
 * @Description: 
 * @FilePath: /iplus-iwt-fe/src/views/eMaintenance/components/ClassTree.vue
-->
<template>
  <div class="tree-container">
    <div class="flex justify-between items-center pr-8px">
      <div class="top-text" v-if="!collapsed">设备类型</div>
      <div class="top-icon">
        <a-icon :type="collapsed ? 'double-right' : 'double-left'" @click="toggle" class="trigger" />
      </div>
    </div>
    <div class="pr-8px w-300px" v-show="!collapsed">
      <a-directory-tree
        :default-selected-keys="defaultExpandedKeys"
        :expandedKeys="defaultExpandedKeys"
        :load-data="onLoadData"
        :loadedKeys="loadedKeys"
        :replaceFields="replaceFields"
        :tree-data="treeData"
        @expand="onExpand"
        @load="loadDept"
        @select="(val,info)=>handleSelect(val,info.node.dataRef)"
        v-if="treeData.length>0"
      />
    </div>
    <!--     :replaceFields="replaceFields"
    -->
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { getAction } from '@/api/manage';

  export default {
    name: 'ClassTree',
    props: {
      value: {
        type: String,
        required: false
      },
    },
    components: {

    },
    // 定义属性
    data () {
      return {
        collapsed: false,
        treeValue: null,
        loadedKeys: [],
        expandedKeys: [],
        isShowAll: false,
        treeData: [],
        defaultExpandedKeys: [],
        replaceFields: {
          key: 'dev_class_code'
        }
      }
    },
    // 计算属性，会监听依赖属性值随之变化
    computed: {
      ...mapGetters([''])
    },
    // 监控data中的数据变化
    watch: {},
    // 生命周期 - 创建完成（可以访问当前this实例）
    created () {
      this.onLoadData()


    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted () {

    },
    // 方法集合
    methods: {
      toggle () {
        this.collapsed = !this.collapsed
        this.$emit('update:collapsed', this.collapsed)

      },
      handleSelect (value, info) {
        if (!value) {
          this.$emit('change', '');
          this.treeValue = null
        } else if (value instanceof Array) {

          this.$emit('change', value.map(item => item).join(','))
          this.treeValue = value
        } else {
          this.$emit('change', value.value, value.label)
          this.treeValue = value
        }
        this.$emit('changeNode', info)
      },
      loadDept (loadedKeys) {
        this.loadedKeys = loadedKeys
      },
      onExpand (keys) {

        // expandedKeys(.sync)	（受控）展开指定的树节点
        this.expandedKeys = keys
      },
      handleLoadTree () {

      },
      onLoadData (treeNode, test) {
        return new Promise(resolve => {

          if (treeNode?.dataRef.children && treeNode?.dataRef.children.length) {
            resolve()
            return
          }


          let id = treeNode?.dataRef.key

          getAction('/sys/dict/loadCustomTreeData', {
            tableName: '`iwt-wf`.dev_class',
            code: 'id',
            text: 'type_name',
            pid: id ?? -1,
            hasChildField: 'has_child',
            pidField: 'pid',
            condition: '',
            order: 'sort_no asc',
            targetFields: 'dev_class_code'
          }).then(res => {

            if (res.success) {
              const result = res.result.map((item) => {
                item.isLeaf = Boolean(item.isLeaf)
                return item
              })

              if (!treeNode) {
                this.defaultExpandedKeys = [result[0].dev_class_code]

                this.treeData = result
                this.$nextTick(() => {
                  this.handleSelect(this.defaultExpandedKeys, result[0])
                })

              } else {
                treeNode.dataRef.children = result
                this.treeData = [...this.treeData]
              }
              resolve()
            }
          })

        });
      },


      onExpand (expandedKeys) {

        this.defaultExpandedKeys = expandedKeys;
        this.autoExpandParent = false;

      },
    },
    model: {
      prop: 'value',
      event: 'change'
    }
  }
</script>

<style lang='scss' scoped>

  .tree-container {
    transition: background 0.3s, width 0.3s cubic-bezier(0.2, 0, 0, 1) 0s;
  }
  .top-text {
    font-weight: 400;
    font-size: 14px;
    flex: 1;
    text-align: center;
  }
  .top-icon {
    line-height: 12px;
    padding: 6px 0px;
    .trigger {
      line-height: 14px;
      padding: 0 6px;
      font-size: 14px;
    }
    &:hover {
      background: rgba(0, 0, 0, 0.05);
    }
  }

</style>